var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 56.3",
    enableBackground: "new 0 0 56.3 56.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.2,17.3c-2,0-4,0-6,0c-2,0-4.1,0-6.1,0c-2.9,0-5,2.1-5.1,5c0,4,0,7.9,0,11.9c0,2.8,2.2,5,5.1,5   c4.1,0,8.1,0,12.2,0c2.9,0,5-2.2,5-5.1c0-3.9,0-7.8,0-11.7C39.2,19.5,37.1,17.3,34.2,17.3z M28,35.1c-3.8,0-6.8-3.1-6.8-6.8   c0-3.8,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9C34.9,32.1,31.9,35.1,28,35.1z M35.3,22.6c-0.9,0-1.6-0.7-1.6-1.5   c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.5,0.7,1.5,1.5C36.8,21.9,36.2,22.6,35.3,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.1,0C12.6,0,0,12.6,0,28.1s12.6,28.1,28.1,28.1s28.1-12.6,28.1-28.1S43.6,0,28.1,0z M41.7,34.4   c0,4-3.2,7.1-7.1,7.2c-2.2,0-4.3,0-6.5,0c-2.2,0-4.3,0-6.5,0c-3.9,0-7.1-3.2-7.1-7.1c0-4.2,0-8.3,0-12.5c0-3.7,3-7,6.7-7   c4.6-0.1,9.2-0.1,13.8,0c3.8,0.1,6.8,3.3,6.8,7.1C41.7,26.2,41.7,30.3,41.7,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.1,23.8c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4C32.5,25.8,30.5,23.8,28.1,23.8   z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramHover);
export default __webpack_public_path__ + "static/media/instagram-hover.a6378ca197526ffb20b4f1c9ae14b5da.svg";
export { ForwardRef as ReactComponent };